import React from "react";
import { DashedLine } from "components/DashedLine";
import IMAGE from "assets/images/our-vision.png";
import { Description } from "../Description";
import { useAboutUsDesc } from "api/aboutUs";

export const OurVision = () => {
  const { data: desc } = useAboutUsDesc();

  return (
    <div className="ab-page">
      <div className="ab-image">
        <div className="ab-image-wrapper">
          <img src={IMAGE} alt="" />
        </div>
      </div>
      <div className="ab-content">
        <div className="ab-title">
          <h1>Our</h1>
          <h1>Vision</h1>
        </div>
        <DashedLine />
        {desc && <Description fullText={desc["OurVision"]} className="ab-desc" />}
      </div>
    </div>
  );
};
